import React from "react";
import { classNames } from "src/common_util";
import { StreamlineIcon } from "src/components/icons";
import loadingSpinnerAnimatedIconUrl from "images/icons/loading-spinner-animated.svg";

const PayButton = ({
  paymentType,
  enabled,
  isLoading = false,
  shouldTakePayment,
  handlePaymentSubmit,
} : {
  paymentType: string | undefined;
  enabled: boolean;
  isLoading?: boolean;
  shouldTakePayment: boolean;
  handlePaymentSubmit: () => void;
}) => {
  const buttonCopy = () => {
    if (!shouldTakePayment)
      return "Confirm order";

    switch (paymentType) {
      case "afterpay_clearpay":
        return "Pay with Afterpay";

      default:
        return "Pay now"
    }
  }

  const classes = classNames({
    "button": true,
    "is-primary": true,
    "is-visually-disabled": !enabled,
    "is-loading": isLoading,
  });

  return (
    <button
      name="button"
      type="submit"
      className={classes}
      disabled={!enabled}
      data-testid="pay_button"
      data-cy="place-order-button"
      onClick={handlePaymentSubmit}
    >
      <span className="loading-icon show-while-loading">
        <StreamlineIcon href={loadingSpinnerAnimatedIconUrl} />
      </span>

      <span className="hide-while-loading">
        {buttonCopy()}
      </span>
    </button>
  );
}

export { PayButton };
